/**
 * API Configuration for CAP Payment
 * Directly builds URL from env string
 */

export interface ICapApiConfig {
  env: string;
  baseUrl: string;
}

/**
 * Get API configuration - builds URL by inserting env string
 * @param env - Required environment string 
 * @throws Error if env is not provided
 */
export const getCapApiConfig = (env?: string): ICapApiConfig => {
  if (!env) {
    throw new Error('Environment (env) parameter is required');
  }
  
  // Build URL by inserting env string directly
  const baseUrl = `https://vakotrade${env}.com`;
  
  console.log(`API Config: env="${env}" -> baseUrl="${baseUrl}"`);
  
  return {
    env,
    baseUrl,
  };
};

